var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main_content wrap"},[_c('Sidebar',{attrs:{"inidata":_vm.dataInitial}}),_c('RightNav',{attrs:{"inidata":_vm.dataInitial}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }